import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-manual-backoffice',
  templateUrl: './manual-backoffice.page.html',
  styleUrls: ['./manual-backoffice.page.scss'],
})
export class ManualBackofficePage implements OnInit {
  @Input() public selectedIndex: any = 1;

  public appPages = [
    {
      title: "External Report",
      url: "/backoffice/external-report",
      isActive: false,
      active: 1,
    },
    {
      title: "Delete Fulltax",
      url: "/backoffice/delete-fulltax",
      isActive: false,
      active: 2,
    },
    {
      title: "Log Etax",
      url: "/backoffice/log-etax",
      isActive: false,
      active: 3,
    },
    {
      title: "Unlock ABB",
      url: "/backoffice/unlock-abb",
      isActive: false,
      active: 4,
    },
  ]
  constructor() { }

  ngOnInit() {
  }

  clickMenu(a) {
    this.selectedIndex = a;
  }

}
